/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import type { ComponentType } from 'react';
import type { LearningItem } from '@akademi/site-builder-runtime';
import { learningItemToCardProps } from '../../cards/learningItemToCardProps';
import type { CourseCardProps } from '../../cards/CourseCard.types';

// CourseCard primitives accept `{ course: CourseCardProps }` — NOT
// the raw CourseCardProps shape directly. This is the registry
// convention; theme primitive overrides also get adapted to this
// shape by `resolveCourseCard`'s `makePrimitiveAdapter`. Skipping
// the wrapper here crashes the BTK theme's CourseCard with a Link
// `href=undefined` error.
//
// Likewise, `learningItemToCardProps` takes `{ tenantSlug, kind? }`
// as its options object, NOT a bare string. Passing the string
// silently produces "/undefined/learn/..." URLs (since string
// values don't have a `.tenantSlug` property).

interface RelatedCoursesProps {
  courses: LearningItem[];
  /** href template per related course. Default {@code /learn/{id}}. */
  courseHrefTemplate?: string;
  /** Theme-resolved CourseCard primitive (already wrapped in the
   *  adapter that accepts `{ course }`). */
  Card: ComponentType<{ course: CourseCardProps }>;
}

export function RelatedCourses({ courses, courseHrefTemplate, Card }: RelatedCoursesProps) {
  if (courses.length === 0) return null;
  return (
    <div className="cd-related">
      {courses.slice(0, 6).map((c) => (
        <Card
          key={c.id}
          course={learningItemToCardProps(
            c,
            courseHrefTemplate ? { hrefTemplate: courseHrefTemplate } : {},
          )}
        />
      ))}
    </div>
  );
}
